import { AppConfig, UserSession, showConnect } from '@stacks/connect';
import { StacksMainnet, StacksTestnet } from '@stacks/network';
import { clientNetwork, stacksApi } from '../lib/constants';
import axios from 'axios';

const appConfig = new AppConfig(["store_write", "publish_data"]);
export const userSession = new UserSession({ appConfig });

//export const network = new StacksTestnet({ url: 'https://api.nakamoto.testnet.hiro.so' });
//export const network = new StacksMainnet({ url: 'https://api.mainnet.hiro.so' });

export const network = ({ network }) => {
  return {
    testnet: new StacksTestnet({ url: 'https://api.nakamoto.testnet.hiro.so' }),
    mainnet: new StacksMainnet({ url: 'https://api.mainnet.hiro.so' })
  }[network];
};

export const authOptions = {
  appDetails: {
    name: 'Derupt',
    icon: window.location.origin + '/favicon.png',
  },
  redirectTo: '/home',
  onFinish: () => {
    window.location.reload();
  },
  userSession: userSession,
};

export function authenticate() {
  showConnect(authOptions);
}

export function logout() {
  userSession.signUserOut(window.location.origin);
}

export function getUserData() {
  if (userSession.isUserSignedIn()) {
    return userSession.loadUserData();
  }
  return null;
}


export function authenticatedUserAddress({ network }) {
  return getUserData()?.profile?.stxAddress[network] || null;
}

export async function userBalance({ token_asset_id }) {
  const userAddress = authenticatedUserAddress({ network: clientNetwork });
  const userBalance = (await axios.get(`${stacksApi}/extended/v1/address/${userAddress}/balances`)).data;
  return { stx: parseInt(userBalance['stx'].balance) || 0, [token_asset_id]: userBalance['fungible_tokens'][token_asset_id]?.balance || 0 }
}

export function isUserSignedIn() {
  return userSession.isUserSignedIn();
}